<template>
    <div class="form-group position-relative">
        <label class="">{{ label }}<required-icon v-if="required"></required-icon></label>
        <input type="search" v-model="query" class="form-control" @focusin="fieldFocused = true" @focusout="fieldUnfocused" @input="search" />
        <small class="text-danger" v-if="error">{{ error }}</small>
        <ul class="list-group position-absolute overflow-auto" :class="{'d-none': !fieldFocused}" style="z-index: 1;">
            <li class="list-group-item" v-for="prediction in predictions" @click="getDetails(prediction)">{{ prediction.description }}</li>
            <li class="list-group-item" v-show="predictions.length > 0"><img src="/storage/powered_by_google_on_white.png" class="float-right"/></li>
        </ul>
    </div>
</template>

<script>

    import { v4 as uuidv4 } from 'uuid';

    import debounce from 'lodash.debounce';
    export default {
        name: 'AddressSearchInput',
        props: ['label', 'error', 'required', 'value'],
        data: () => {
            return {
                fieldFocused: false,
                service: null,
                query: null,
                predictions: [],
                address: {},
                sessionToken: null,
            }
        },
        watch: {
            value: {
                handler: function (val) {
                    this.query = val
                },
                immediate: true,
            },
        },
        methods: {
            fieldUnfocused () {
                //To allow for click to get through before closing
                setTimeout(() => {this.fieldFocused = false}, 200)
            },
            search: debounce(function() {
                this.$emit('input', this.query);
                if (this.query.length === 0) {
                    this.predictions = []
                    return
                }
                const options = {
                    input: this.query,
                    language: lgt.language,
                    sessiontoken: this.sessionToken,
                }
                axios.post('/address/search', options).then((response) => {
                    this.predictions = response.data.predictions
                })
            }, 450, {'maxWait': 1000}),
            getDetails (prediction) {
                const options = {
                    place_id: prediction.place_id,
                    language: lgt.language,
                    sessiontoken: this.sessionToken,
                }
                axios.post('/address/details', options).then((response) => {
                    this.address = this.parseAddressComponent(response.data.result)
                    this.query = this.address.address
                    this.$emit('details', this.address)
                    this.sessionToken = uuidv4()
                })
            },
            parseAddressComponent (place) {
                //taken from (but modified a bit) https://github.com/ajoslin/parse-google-place/blob/master/index.js
                place = place || {}

                let byType = (place.address_components || []).reduce(function (acc, data) {
                    data.types.forEach(function (type) {
                        acc[type] = data
                    })
                    return acc
                }, {})

                let name = '';
                if(place.types.includes('establishment')){
                    name = place.name;
                }

                let result = {
                    name: name,
                    streetNumber: placeGet('street_number'),
                    streetName: placeGet('route'),
                    city: placeGet('locality') ||
                        placeGet('sublocality') ||
                        placeGet('sublocality_level_1') ||
                        placeGet('neighborhood') ||
                        placeGet('administrative_area_level_3') ||
                        placeGet('administrative_area_level_2'),
                    county: placeGet('administrative_area_level_2'),
                    stateShort: placeGet('administrative_area_level_1', true),
                    stateLong: placeGet('administrative_area_level_1'),
                    countryShort: placeGet('country', true),
                    countryLong: placeGet('country'),
                    zipCode: placeGet('postal_code'),
                    lat: place.geometry.location.lat,
                    lng: place.geometry.location.lng,
                }

                result.address = [
                    result.streetName,
                    result.streetNumber,
                ].filter(Boolean).join(' ')

                return result

                function placeGet (key, short) {
                    if (!(key in byType)) return ''

                    return short ? byType[key].short_name : byType[key].long_name
                }
            },
        },
        created () {
            this.sessionToken = uuidv4()
        },
    }
</script>
